import { Box, Button, Typography, IconButton, Tooltip } from "@mui/material"

import landmarkIcon from '../../assets/landmark icon.svg'
import { useNavigate } from "react-router-dom"
import { downloadBuildingIds } from "../../services/api"
import { useState } from "react"

let baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_URL : process.env.REACT_APP_REMOTE_URL

const userDetails = JSON.parse(localStorage.getItem("user"))

const VenueCard = ({ data }) => {



    const navigate = useNavigate()

    let address = data.address.split(',')
    let location = address[address.length - 4] + "," + address[address.length - 3]

    const handleDownloadLandmarkIds = async (venueName) => {
        await downloadBuildingIds(venueName)
    }

    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(data.venueName);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (


        <Box
            sx={{
                p: 2.5,
                border: "1px solid #e0e0e0",
                borderRadius: 3,
                background: "#fafafa",
                display: "flex",
                flexDirection: "column",
                gap: 2
            }}
        >

            {/* TOP ROW — LABEL + VALUE + COPY */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                    sx={{
                        background: "linear-gradient(135deg, #1976d2, #1565c0)",
                        color: "#fff",
                        fontSize: 10,
                        fontWeight: 700,
                        px: 2,
                        py: 1,
                        borderRadius: "20px",
                        letterSpacing: 0.5,
                    }}
                >
                    VENUE NAME
                </Box>

                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 700,
                        color: "#222",
                        flexGrow: 1,
                    }}
                >
                    {data.venueName}
                </Typography>

                <Tooltip title={copied ? "Copied!" : "Copy"}>
                    <IconButton
                        onClick={handleCopy}
                        size="small"
                        sx={{
                            bgcolor: copied ? "success.light" : "grey.100",
                            borderRadius: 2,
                            width: 36,
                            height: 36,
                            boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                            transition: "0.3s",
                            "&:hover": {
                                bgcolor: copied ? "success.main" : "grey.200",
                                transform: "scale(1.07)",
                            },
                        }}
                    >
                        {copied ? "✔️" : "📋"}
                    </IconButton>
                </Tooltip>
            </Box>

            {/* ACTION BUTTONS */}
            <Box sx={{ display: "flex", gap: 1.5 }}>
                {userDetails?.roles?.includes("super_admin") && (
                    <Button
                        variant="contained"
                        size="small"
                        sx={{ textTransform: "none" }}
                        onClick={() => navigate("/" + data?.venueName)}
                    >
                        Open V1 Map
                    </Button>
                )}

                <Button
                    variant="contained"
                    size="small"
                    sx={{ textTransform: "none" }}
                    onClick={() => navigate("/geojson/" + data?.venueName)}
                >
                    Open Map
                </Button>

                <Button
                    variant="contained"
                    size="small"
                    sx={{ textTransform: "none" }}
                    onClick={() => handleDownloadLandmarkIds(data?.venueName)}
                >
                    Download Landmark IDs
                </Button>
            </Box>

            {/* LOCATION ROW */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                    src={landmarkIcon}
                    style={{
                        width: 18,
                        filter: "invert(0.5)",
                        opacity: 0.8,
                    }}
                />

                <Typography
                    sx={{ color: "#757575", fontSize: 14, fontWeight: 500 }}
                >
                    {location}
                </Typography>
            </Box>

            {/* DISTANCE */}
            {data.distance && data.distance / 1000 > 0.1 && (
                <Typography
                    sx={{
                        color: "#34b9b0",
                        fontSize: 15,
                        fontWeight: 600,
                        letterSpacing: 0.2,
                    }}
                >
                    {(data.distance / 1000).toFixed(1)} km from you
                </Typography>
            )}

        </Box>

    )
}

export default VenueCard